import {
  Box,
  Button,
  FormHelperText,
  IconButton,
  styled,
  Typography,
} from '@mui/material';
import { SketchPicker } from 'react-color';

export const IconWrapper = styled(IconButton)(
  ({ $backgroundColor, selected, theme, $showBorder }) => `
  &,
  &.Mui-disabled {
    background-color: ${$backgroundColor};
  }
  width: 50px;
  display: flex;
  flex-direction: column;
  justify-content: center;
  align-items: center;
  border-radius: 10%;
  border: ${
    selected
      ? `3px solid ${theme.palette.brand.blue}`
      : `0.05rem solid ${
          $showBorder
            ? theme.palette.brand.borderGrey
            : theme.palette.common.white
        }`
  };
  min-height: 50px;
  padding: 0;
`,
);

export const PickerWrapper = styled(Box)(
  ({ $colorPickerMode }) => `
  ${$colorPickerMode === 'block' ? 'top: 65px; left: -60px;' : ''}
  cursor: auto;
  position: absolute;
  z-index: 1300;
  box-shadow: 0px 0px 8px 0px rgba(0, 0, 0, 0.2);
  border-radius: 5px;

  & .saturation-white {
    cursor: crosshair;
  }
`,
);

export const ColorBar = styled(Box)(
  ({ theme, color }) => `
    width: 100%;
    height: 0.25rem;
    background: ${color ? color : theme.palette.brand.black};
    border-radius: 0.1875rem;
`,
);

export const InputLabel = styled(Typography)`
  font-weight: 400;
  max-width: 100%;
  white-space: nowrap;
  overflow: hidden;
  text-overflow: ellipsis;
`;

export const ColorWidgetHelperText = styled(FormHelperText)`
  color: ${(props: any) =>
    props.error ? props.theme.palette.secondary.main : 'initial'};
`;

export const Container = styled(Box)`
  display: flex;
  align-items: start;
  flex-direction: column;
  gap: 6px;
`;

export const ColorPickerCloseButton = styled(Button)(
  ({ theme }) => `
    background-color: ${theme.palette.common.white};
    box-shadow: none;
    width: auto;
    min-width: 0;
    padding: 2px;
    float: right;
    color: ${theme.palette.brand.darkGrey};
    border-radius: 50%;
    margin: 3px;
    &:hover {
      box-shadow: none;
      background-color: ${theme.palette.brand.whitesmoke};
    }
  `,
);

export const StyledSketchPicker = styled(SketchPicker)`
  [id^='rc-editable-input-'] {
    width: 100% !important;
    padding: 4px 5% 3px !important;
  }

  .flexbox-fix:nth-of-type(3) > :first-child {
    flex: 4 1 0% !important;
  }
`;
